import { createContext } from "react";


// create a new context using createContext
const noteContext = createContext();

export default noteContext;